import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonComponent } from '@toteimlib/angular-lib';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { InputErrorComponent } from 'app/components/shared/components/input-error.component';
import { ProgressSpinner } from '@openng/optimus-ui/progressspinner';
import { InputTextModule } from '@openng/optimus-ui/inputtext';
import { RadioButtonModule } from '@openng/optimus-ui/radiobutton';
import { Tooltip } from '@openng/optimus-ui/tooltip';

export const imports: any[] = [
  InputTextModule,
  RadioButtonModule,
  FormsModule,
  ButtonComponent,
  ProgressSpinner,
  TranslateDirective,
  TranslatePipe,
  ReactiveFormsModule,
  InputErrorComponent,
  FaIconComponent,
  Tooltip
];
